"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeSections = require("@shopify/theme-sections");

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _shopifyCart = require("shopify-cart");

var _shopifyCart2 = _interopRequireDefault(_shopifyCart);

var _indexUnoptimized = require("shopify-buy/index.unoptimized.umd");

var _indexUnoptimized2 = _interopRequireDefault(_indexUnoptimized);

var _bignumber = require("bignumber.js");

var _bignumber2 = _interopRequireDefault(_bignumber);

var _handlebarsMin = require("handlebars/dist/handlebars.min.js");

var _handlebarsMin2 = _interopRequireDefault(_handlebarsMin);

var _themeCurrency = require("@shopify/theme-currency");

var _handlebarsHelpers = require("../modules/handlebars-helpers");

var _handlebarsHelpers2 = _interopRequireDefault(_handlebarsHelpers);

var _slickCarousel = require("slick-carousel");

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require("../modules/slick");

var _slick2 = _interopRequireDefault(_slick);

require("../../styles/sections/index-quiz.scss");

require("../../styles/sections/index-quiz-results.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productMatchesSkinType = function productMatchesSkinType(_ref) {
  var product = _ref.product,
      skinType = _ref.skinType;

  return product.tags.includes("quiz:skintype:" + skinType);
};

var productMatchesConcern = function productMatchesConcern(_ref2) {
  var product = _ref2.product,
      concern = _ref2.concern;

  // this conditional was introduced to map wrong tags introduced by error.
  if (concern === "sensitivity") {
    return product.tags.includes("quiz:concerns:sensitive") || product.tags.includes("quiz:concerns:sensitivity");
  }
  if (concern === "pigmentation") {
    return product.tags.includes("quiz:concerns:pigmentation") || product.tags.includes("quiz:concerns:large pigmentation");
  }
  return product.tags.includes("quiz:concerns:" + concern);
};

var productMatchesAge = function productMatchesAge(_ref3) {
  var product = _ref3.product,
      age = _ref3.age;

  return product.tags.includes("quiz:age:" + age);
};

var productMatchesQuiz = function productMatchesQuiz(_ref4) {
  var product = _ref4.product,
      quizResponse = _ref4.quizResponse;

  var skinTypeMatch = false;
  if (productMatchesSkinType({ product: product, skinType: quizResponse.skinType })) {
    skinTypeMatch = true;
  }
  var concernsMatch = [false, false];
  quizResponse.concerns.forEach(function (concern, i) {
    if (productMatchesConcern({ product: product, concern: concern })) {
      concernsMatch[i] = true;
    }
  });
  var ageMatch = false;
  if (productMatchesAge({ product: product, age: quizResponse.age })) {
    ageMatch = true;
  }

  var primaryMatch = concernsMatch[0] && concernsMatch[1] && skinTypeMatch && ageMatch;
  var secondaryMatch = concernsMatch[0] || skinTypeMatch && ageMatch;
  var ternaryMatch = concernsMatch[1] || skinTypeMatch && ageMatch;
  var quaternaryMatch = skinTypeMatch && ageMatch;

  if (primaryMatch) return 1;
  if (secondaryMatch) return 2;
  if (ternaryMatch) return 3;
  if (quaternaryMatch) return 4;
};

var productIsPinned = function productIsPinned(product) {
  var pinned = false;
  product.tags.forEach(function (tag) {
    if (tag.includes("quiz:pin")) {
      pinned = true;
    }
  });
  return pinned;
};

var productIsDefault = function productIsDefault(product) {
  var isDefault = false;
  product.tags.forEach(function (tag) {
    if (tag.includes("quiz:default")) {
      isDefault = true;
    }
  });
  return isDefault;
};

var pinnedProductMatchesQuiz = function pinnedProductMatchesQuiz(_ref5) {
  var product = _ref5.product,
      quizResponse = _ref5.quizResponse;

  if (productIsPinned(product)) {
    var skinTypeMatch = false;
    if (productMatchesSkinType({ product: product, skinType: quizResponse.skinType })) {
      skinTypeMatch = true;
    }
    var concernsMatch = false;
    if (productMatchesConcern({ product: product, concern: quizResponse.concerns[0] })) {
      concernsMatch = true;
    }
    var ageMatch = false;
    if (productMatchesAge({ product: product, age: quizResponse.age })) {
      ageMatch = true;
    }
    var match = skinTypeMatch && concernsMatch && ageMatch;

    return match;
  }
  return false;
};

var fetchProducts = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref7) {
    var after = _ref7.after,
        client = _ref7.client;
    var productsQuery, res, products;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            productsQuery = client.graphQLClient.query(function (root) {
              root.addConnection("products", { args: Object.assign({ first: 100 }, after && { after: after }) }, function (product) {
                var productFields = ["title", "id", "description", "productType", "tags", "handle", "onlineStoreUrl"];
                productFields.forEach(function (field) {
                  product.add(field);
                });
                product.addConnection("images", { args: { first: 100 } }, function (image) {
                  return image.add("originalSrc");
                });
                product.addConnection("variants", { args: { first: 50 } }, function (variant) {
                  variant.add("title");
                  variant.add("id");
                  variant.add("priceV2", function (price) {
                    price.add("amount");
                  });
                  variant.add("compareAtPriceV2", function (compareAtPrice) {
                    compareAtPrice.add("amount");
                  });
                });
              });
            });
            _context.next = 3;
            return client.graphQLClient.send(productsQuery);

          case 3:
            res = _context.sent;
            products = res.data.products;
            return _context.abrupt("return", products);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function fetchProducts(_x) {
    return _ref6.apply(this, arguments);
  };
}();

var fetchAllProducts = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(quizResponse) {
    var client, matchingProducts, matchingPinnedProducts, skinTypeMatches, primaryConcernMatches, secondaryConcernMatches, ageMatches, hasNextPage, after, defaultProducts, products;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = _indexUnoptimized2.default.buildClient({
              domain: "sukinnaturals.com.au",
              storefrontAccessToken: "49b11e2758f81ef44fa413586c8f471b"
            });
            matchingProducts = [];
            matchingPinnedProducts = [];
            skinTypeMatches = [];
            primaryConcernMatches = [];
            secondaryConcernMatches = [];
            ageMatches = [];
            hasNextPage = void 0;
            after = void 0;
            defaultProducts = [];

          case 10:
            _context2.next = 12;
            return fetchProducts({ client: client, after: after });

          case 12:
            products = _context2.sent;

            hasNextPage = products.pageInfo.hasNextPage;
            after = products.edges[products.edges.length - 1].cursor;
            products.edges.forEach(function (edge) {
              var product = edge.node;
              product.images = product.images.edges.map(function (edge) {
                return edge.node.originalSrc;
              });
              product.variants = product.variants.edges.map(function (edge) {
                return edge.node;
              });
              var match = productMatchesQuiz({ product: product, quizResponse: quizResponse });

              if (match) {
                product.baseScore = match * 100;
                matchingProducts.push(product);
              }
              if (pinnedProductMatchesQuiz({ product: product, quizResponse: quizResponse })) {
                matchingPinnedProducts.push(product);
              }
              if (productMatchesSkinType({
                product: product,
                skinType: quizResponse.skinType
              })) {
                skinTypeMatches.push(product);
              }
              if (productMatchesConcern({
                product: product,
                concern: quizResponse.concerns[0]
              })) {
                primaryConcernMatches.push(product);
              }
              if (productMatchesConcern({
                product: product,
                concern: quizResponse.concerns[1]
              })) {
                secondaryConcernMatches.push(product);
              }
              if (productMatchesAge({ product: product, age: quizResponse.age })) {
                ageMatches.push(product);
              }
              if (productIsDefault(product)) {
                defaultProducts.push(product);
              }
            });

          case 16:
            if (hasNextPage) {
              _context2.next = 10;
              break;
            }

          case 17:
            return _context2.abrupt("return", {
              matchingProducts: matchingProducts,
              matchingPinnedProducts: matchingPinnedProducts,
              skinTypeMatches: skinTypeMatches,
              ageMatches: ageMatches,
              primaryConcernMatches: primaryConcernMatches,
              secondaryConcernMatches: secondaryConcernMatches,
              defaultProducts: defaultProducts
            });

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function fetchAllProducts(_x2) {
    return _ref8.apply(this, arguments);
  };
}();

var rankProducts = function rankProducts(products) {
  var rankedProducts = [];
  products.forEach(function (product) {
    var productScore = product.tags.filter(function (tag) {
      if (!tag.includes("quiz:default")) {
        return tag.includes("quiz:");
      }
      return false;
    }).length + product.baseScore;
    rankedProducts.push(Object.assign({}, product, {
      score: productScore
    }));
  });
  rankedProducts.sort(function (a, b) {
    return a.score - b.score;
  });
  return rankedProducts;
};

var findOverride = function findOverride(_ref9) {
  var products = _ref9.products,
      productType = _ref9.productType;

  if (Array.isArray(productType)) return;
  var tagMatch = "quiz:override:" + productType.toLowerCase();
  var override = products.find(function (product) {
    return product.tags.includes(tagMatch);
  });
  return override;
};

var findPinnedProduct = function findPinnedProduct(_ref10) {
  var products = _ref10.products,
      productType = _ref10.productType;

  if (Array.isArray(productType)) return;
  var tagMatch = "quiz:pinned";
  var pinnedProduct = products.find(function (product) {
    return product.tags.includes(tagMatch);
  });
  return pinnedProduct;
};

var getBestMatch = function getBestMatch(_ref11) {
  var products = _ref11.products,
      productType = _ref11.productType,
      defaultProducts = _ref11.defaultProducts;


  var override = findOverride({ products: products, productType: productType });
  if (override) {
    return override;
  }

  var pinned = findPinnedProduct({ products: products, productType: productType });

  if (pinned) {
    return pinned;
  }

  var bestMatch = products.find(function (product) {
    if (Array.isArray(productType)) {
      var found = [];
      productType.forEach(function (type) {
        if (type === product.productType) {
          found.push(product);
        }
      });
      var rankedMatches = rankProducts(found)[0];
      return rankedMatches;
    }
    return product.productType === productType;
  });
  if (!bestMatch) {
    var defaultProduct = defaultProducts.find(function (product) {
      var found = false;
      if (Array.isArray(productType)) {
        productType.forEach(function (type) {
          if (type === product.productType) {
            product.tags.forEach(function (tag) {
              if (tag.includes("quiz:default")) {
                found = true;
              }
            });
          }
        });
      } else if (product.productType === productType) {
        product.tags.forEach(function (tag) {
          if (tag.includes("quiz:default")) {
            found = true;
          }
        });
      }
      return found;
    });
    return defaultProduct;
  }

  return bestMatch;
};

var getPinnedProductPosition = function getPinnedProductPosition(pinnedProduct) {
  var pinnedTag = pinnedProduct.tags.find(function (tag) {
    return tag.includes("quiz:pin");
  });
  var position = pinnedTag.split("quiz:pin:")[1];
  return position;
};

var calcTotalPrice = function calcTotalPrice(products) {
  var total = new _bignumber2.default(0);

  products.forEach(function (product) {
    if (typeof product.variants != "undefined") {
      var price = new _bignumber2.default(product.variants[0].priceV2.amount);
      total = total.plus(price);
    }
  });

  return total.toFixed(2);
};

var calcDiscountPrice = function calcDiscountPrice(totalPrice) {
  return new _bignumber2.default(totalPrice).times("0.85").toFixed(2);
};

var getShortDescription = function getShortDescription(longDescription) {
  return longDescription.split(" ").slice(0, 20).join(" ") + "...";
};

var getProductJSON = function () {
  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref13) {
    var url = _ref13.url,
        product = _ref13.product,
        index = _ref13.index;

    var response, _ref14, product_id, variant_id;

    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetch(url);

          case 2:
            response = _context3.sent;
            _context3.next = 5;
            return response.json();

          case 5:
            _ref14 = _context3.sent;
            product_id = _ref14.product_id;
            variant_id = _ref14.variant_id;
            return _context3.abrupt("return", Object.assign({}, product, {
              product_id: product_id,
              variant_id: variant_id,
              index: index,
              shortDescription: typeof product != "undefined" ? getShortDescription(product.description) : ""
            }));

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function getProductJSON(_x3) {
    return _ref12.apply(this, arguments);
  };
}();

var getProductAndVariantIDs = function () {
  var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(row) {
    var promises, i, products, variantIds;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            promises = [];

            for (i = 0; i < row.length; i++) {
              if (row[i]) {
                promises.push(getProductJSON({
                  url: "/products/" + row[i].handle + "?view=json",
                  product: row[i],
                  index: i + 1
                }));
              }
            }

            _context4.next = 4;
            return Promise.all(promises);

          case 4:
            products = _context4.sent;
            variantIds = products.map(function (product) {
              return product.variant_id;
            }).join(",");
            return _context4.abrupt("return", { variantIds: variantIds, row: products });

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function getProductAndVariantIDs(_x4) {
    return _ref15.apply(this, arguments);
  };
}();

var buildTopRow = function () {
  var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(rowData) {
    var topRow, _ref17, variantIds, row, totalPriceTopRow, topProducts;

    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            topRow = [rowData.cleanser, rowData.toner, rowData.moisturiser, rowData.sunscreen];


            if (rowData.pinnedProduct) {
              topRow.splice(rowData.pinnedProduct.position - 1, 0, rowData.pinnedProduct.product);
            }

            // Add 1 based index after adding pinned product
            _context5.next = 4;
            return getProductAndVariantIDs(topRow);

          case 4:
            _ref17 = _context5.sent;
            variantIds = _ref17.variantIds;
            row = _ref17.row;
            totalPriceTopRow = calcTotalPrice(row);
            topProducts = {
              products: row,
              productPrice: "$" + totalPriceTopRow,
              discountPrice: "$" + calcDiscountPrice(totalPriceTopRow),
              variantIds: variantIds
            };
            return _context5.abrupt("return", topProducts);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function buildTopRow(_x5) {
    return _ref16.apply(this, arguments);
  };
}();

var buildBottomRow = function () {
  var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(_ref19) {
    var rowData = _ref19.rowData,
        age = _ref19.age;

    var bottomRow, _ref20, row, totalPriceBottomRow, bottomProducts;

    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            bottomRow = [rowData.oilsSerums, rowData.nightCream, rowData.eyeLip, rowData.masques];


            if (age === "<20" || age === "20s" || age === "30s") {
              bottomRow = [rowData.masques, rowData.oilsSerums, rowData.scrubs, rowData.eyeLip];
            }

            _context6.next = 4;
            return getProductAndVariantIDs(bottomRow);

          case 4:
            _ref20 = _context6.sent;
            row = _ref20.row;
            totalPriceBottomRow = calcTotalPrice(row);
            bottomProducts = {
              products: row,
              productPrice: "$" + totalPriceBottomRow,
              discountPrice: "$" + calcDiscountPrice(totalPriceBottomRow)
            };
            return _context6.abrupt("return", bottomProducts);

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, undefined);
  }));

  return function buildBottomRow(_x6) {
    return _ref18.apply(this, arguments);
  };
}();

var getRows = function () {
  var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
    var urlParams, quizResponse, _ref22, matchingProducts, skinTypeMatches, ageMatches, primaryConcernMatches, secondaryConcernMatches, defaultProducts, matchingPinnedProducts, rankedProducts, pinnedProducts, topRowData, oilSerumProductType, masquesProductType, nightCreamProductType, scrubsProductType, eyeLipProductType, oilSerumProduct, masquesProduct, bottomRowData, _ref23, _ref24, topRow, bottomRow;

    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            urlParams = new URLSearchParams(window.location.search);
            quizResponse = {
              skinType: urlParams.get("skintype"),
              concerns: urlParams.get("concerns").split(","),
              age: urlParams.get("age")
            };
            _context7.next = 4;
            return fetchAllProducts(quizResponse);

          case 4:
            _ref22 = _context7.sent;
            matchingProducts = _ref22.matchingProducts;
            skinTypeMatches = _ref22.skinTypeMatches;
            ageMatches = _ref22.ageMatches;
            primaryConcernMatches = _ref22.primaryConcernMatches;
            secondaryConcernMatches = _ref22.secondaryConcernMatches;
            defaultProducts = _ref22.defaultProducts;
            matchingPinnedProducts = _ref22.matchingPinnedProducts;
            rankedProducts = rankProducts(matchingProducts);
            pinnedProducts = rankProducts(matchingPinnedProducts);
            topRowData = Object.assign({
              toner: getBestMatch({
                products: rankedProducts,
                productType: "Toner",
                defaultProducts: defaultProducts
              }),
              cleanser: getBestMatch({
                products: rankedProducts,
                productType: "Cleanser",
                defaultProducts: defaultProducts
              }),
              moisturiser: getBestMatch({
                products: rankedProducts,
                productType: "Moisturiser",
                defaultProducts: defaultProducts
              }),
              sunscreen: getBestMatch({
                products: rankedProducts,
                productType: "Sunscreen",
                defaultProducts: defaultProducts
              })
            }, pinnedProducts.length && {
              pinnedProduct: {
                product: pinnedProducts[0],
                position: getPinnedProductPosition(pinnedProducts[0])
              }
            });
            oilSerumProductType = ["Facial Oil", "Facial Serum"];
            masquesProductType = "Facial Masque";
            nightCreamProductType = "Night Cream";
            scrubsProductType = "Scrub";
            eyeLipProductType = ["Eye Cream", "Eye Serum", "Lip"];
            oilSerumProduct = getBestMatch({
              products: rankProducts(primaryConcernMatches),
              productType: oilSerumProductType,
              defaultProducts: defaultProducts
            });


            if (!oilSerumProduct) {
              oilSerumProduct = getBestMatch({
                products: rankProducts(secondaryConcernMatches),
                productType: oilSerumProductType,
                defaultProducts: defaultProducts
              });
            }

            masquesProduct = getBestMatch({
              products: rankProducts(primaryConcernMatches),
              productType: masquesProductType,
              defaultProducts: defaultProducts
            });


            if (!masquesProduct) {
              masquesProduct = getBestMatch({
                products: rankProducts(secondaryConcernMatches),
                productType: masquesProductType,
                defaultProducts: defaultProducts
              });
            }

            bottomRowData = {
              nightCream: getBestMatch({
                products: rankProducts(skinTypeMatches),
                productType: nightCreamProductType,
                defaultProducts: defaultProducts
              }),
              oilsSerums: oilSerumProduct,
              masques: masquesProduct,
              scrubs: getBestMatch({
                products: rankProducts(skinTypeMatches),
                productType: scrubsProductType,
                defaultProducts: defaultProducts
              }),
              eyeLip: getBestMatch({
                products: rankProducts(ageMatches),
                productType: eyeLipProductType,
                defaultProducts: defaultProducts
              })
            };
            _context7.t0 = Promise;
            _context7.t1 = buildTopRow(topRowData);
            _context7.next = 29;
            return buildBottomRow({
              rowData: bottomRowData,
              age: quizResponse.age
            });

          case 29:
            _context7.t2 = _context7.sent;
            _context7.t3 = [_context7.t1, _context7.t2];
            _context7.next = 33;
            return _context7.t0.all.call(_context7.t0, _context7.t3);

          case 33:
            _ref23 = _context7.sent;
            _ref24 = (0, _slicedToArray3.default)(_ref23, 2);
            topRow = _ref24[0];
            bottomRow = _ref24[1];
            return _context7.abrupt("return", { topRow: topRow, bottomRow: bottomRow });

          case 38:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, undefined);
  }));

  return function getRows() {
    return _ref21.apply(this, arguments);
  };
}();

var getParameterByName = function getParameterByName(name) {
  var url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

var buildParameterString = function buildParameterString() {
  var parameters = ["skintype", "concerns", "age", "live"];
  var paramString = "";
  parameters.forEach(function (param, i) {
    var paramValue = getParameterByName(param);
    if (paramValue != null) {
      paramString += paramValue + " | ";
    }
  });

  var feelingValue = getParameterByName("feeling");
  var workValue = getParameterByName("work");
  var sleepValue = getParameterByName("sleep");

  if (feelingValue != null) {
    paramString += feelingValue == "yes" ? "stressed | " : "not stressed | ";
  }
  if (workValue != null) {
    paramString += workValue == "indoors" ? "work indoors | " : "work outdoors | ";
  }
  if (sleepValue != null) {
    paramString += sleepValue == "yes" ? "getting enough sleep" : "not getting enough sleep";
  }

  var quizParametersContainer = document.querySelector("#QuizParameters");

  if (quizParametersContainer) {
    quizParametersContainer.innerHTML = paramString;
  }

  return paramString;
};

var buildHandlebars = function buildHandlebars(_ref25) {
  var topRow = _ref25.topRow,
      bottomRow = _ref25.bottomRow;

  var quizTopResults = document.querySelector("#QuizTopResults");
  var quizTopProductsContainer = document.querySelector("#QuizTopProductsContainer");
  if (quizTopProductsContainer && typeof topRow.products[0] != "undefined") {
    var quizTopProductHandlebars = _handlebarsMin2.default.compile(quizTopResults.innerHTML);
    quizTopProductsContainer.innerHTML = quizTopProductHandlebars(topRow);
  } else {
    quizTopProductsContainer.classList.add("hide");
  }

  var quizBottomResults = document.querySelector("#QuizBottomResults");
  var quizBottomProductsContainer = document.querySelector("#QuizBottomProductsContainer");
  if (quizBottomProductsContainer && typeof bottomRow.products[0] != "undefined") {
    var quizBottomProductHandlebars = _handlebarsMin2.default.compile(quizBottomResults.innerHTML);
    quizBottomProductsContainer.innerHTML = quizBottomProductHandlebars(bottomRow);
  } else {
    quizBottomProductsContainer.classList.add("hide");
  }
};

var buildSlickSliders = function buildSlickSliders() {
  // Top row slider
  var topProducts = (0, _jquery2.default)("[data-quiz-top-products]");

  if (topProducts.length) {
    var top_limit = (0, _jquery2.default)(topProducts).data("top-products");
    var top_limit_medium = (0, _jquery2.default)(topProducts).data("medium-top-products");

    var top_settings = (0, _slick2.default)({
      appendArrows: (0, _jquery2.default)(topProducts).closest(".slick-slider-wrapper").find(".slick-arrows"),
      arrows: true,
      infinite: false,
      slidesToShow: top_limit,
      slidesToScroll: top_limit,
      // prevArrow: $(container).find('[data-slick-prev]'),
      // nextArrow: $(container).find('[data-slick-next]'),
      responsive: [{
        breakpoint: Breakpoints["large"],
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: Breakpoints["small"],
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });

    topProducts.slick(top_settings);
  }

  // Bottom row slider
  var bottomProducts = (0, _jquery2.default)("[data-quiz-bottom-products]");

  if (bottomProducts.length) {
    var bottom_limit = (0, _jquery2.default)(bottomProducts).data("bottom-products");
    var bottom_limit_medium = (0, _jquery2.default)(bottomProducts).data("medium-bottom-products");

    var bottom_settings = (0, _slick2.default)({
      appendArrows: (0, _jquery2.default)(bottomProducts).closest(".slick-slider-wrapper").find(".slick-arrows"),
      arrows: true,
      infinite: false,
      slidesToShow: bottom_limit,
      slidesToScroll: bottom_limit,
      responsive: [{
        breakpoint: Breakpoints["medium"],
        settings: {
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: Breakpoints["small"],
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });

    bottomProducts.slick(bottom_settings);
  }
};

exports.default = (0, _themeSections.register)("index-quiz-results", {
  onLoad: function onLoad() {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
      var _ref26, topRow, bottomRow, loadingState, trigger, addRegimeToCart;

      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return getRows();

            case 2:
              _ref26 = _context8.sent;
              topRow = _ref26.topRow;
              bottomRow = _ref26.bottomRow;


              buildParameterString();
              _context8.next = 8;
              return buildHandlebars({ topRow: topRow, bottomRow: bottomRow });

            case 8:
              buildSlickSliders();

              loadingState = document.querySelector(".quiz-anchor");

              loadingState.classList.remove("is-loading");

              trigger = new Event("lazy:reload");

              document.dispatchEvent(trigger);

              addRegimeToCart = document.querySelector("[data-add-to-cart-regime]");

              addRegimeToCart.addEventListener("click", function () {
                var variantIds = (0, _jquery2.default)(addRegimeToCart).attr("data-quick-add-regime").split(",");
                variantIds.forEach(function (variantId) {
                  var product = {
                    id: variantId,
                    quantity: 1,
                    properties: { discount: "15_percent_off" }
                  };
                  window.AjaxCart.addItem(product);
                });
              });

              // Ajax cart callbacks
              document.addEventListener("cart:sending", function (event) {
                var response = event.detail.response;
                if (response.type == "addItem" && addRegimeToCart) {
                  addRegimeToCart.classList.add("is-adding");
                  if (addRegimeToCart.querySelector("[data-add-to-cart-text]")) {
                    addRegimeToCart.querySelector("[data-add-to-cart-text]").innerHTML = theme.strings.addingToCart;
                  }
                }
              });

              document.addEventListener("cart:requestsCompleted", function (event) {
                if (addRegimeToCart) {
                  addRegimeToCart.classList.remove("is-adding");
                  if (addRegimeToCart.querySelector("[data-add-to-cart-text]")) {
                    addRegimeToCart.querySelector("[data-add-to-cart-text]").innerHTML = theme.strings.addToCart;
                  }
                }
              });

              (0, _jquery2.default)(document).on("submit", "#newsletter_subscribe", function (e) {
                e.preventDefault();

                var productData = [topRow.products, bottomRow.products];

                var _learnq = window._learnq || [];
                _learnq.push(["track", "Skincare Quiz recommended products", { productData: productData }]);

                var urlParams = new URLSearchParams(window.location.search);
                var quizResponse = {
                  age: urlParams.get("age"),
                  concerns: urlParams.get("concerns").split(","),
                  feeling: urlParams.get("feeling"),
                  live: urlParams.get("live"),
                  skinType: urlParams.get("skintype"),
                  sleep: urlParams.get("sleep"),
                  work: urlParams.get("work")
                };

                _learnq.push(["track", "Skincare quiz answers", quizResponse]);

                _learnq.push(["identify", {
                  // Change the line below to dynamically populate the user's email.
                  $email: (0, _jquery2.default)(this).find(".newsletter_subscribe_email").val()
                }]);

                (0, _jquery2.default)(this).find(".form-body").addClass("hide");
                (0, _jquery2.default)(this).find(".form-message").removeClass("hide");

                // GA event to fire on successful supscription of newsletter
                dataLayer.push({ event: "gtm-quiz-subscribe" });
              });

            case 18:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this);
    }))();
  },
  onUnload: function onUnload() {}
});